import { Configs } from '@shared/models';

import { BOREAS_CONFIG } from './configs/boreas.config';
import { CETOINE_CONFIG } from './configs/cetoine.config';
import { CHONDRUS_CONFIG } from './configs/chondrus.config';
import { CYGNUS_CONFIG } from './configs/cygnus.config';
import { DEFAULT_CONFIG } from './configs/default.config';
import { DRACO_CONFIG } from './configs/draco.config';
import { HYDRA_CONFIG } from './configs/hydra.config';
import { LACERTA_CONFIG } from './configs/lacerta.config';
import { LYNX_CONFIG } from './configs/lynx.config';
import { NIX_CONFIG } from './configs/nix.config';
import { PONA_CONFIG } from './configs/pona.config';
import { SCORPIO_CONFIG } from './configs/scorpio.config';
import { SHANE_CONFIG } from './configs/shane.config';
import { STELLAR_CONFIG } from './configs/stellar.config';
import { RETAILERS } from './retailers';

export const RETAILERS_CONFIG_MAP: Record<RETAILERS, Configs> = {
  [RETAILERS.NIX]: NIX_CONFIG,
  [RETAILERS.PONA]: PONA_CONFIG,
  [RETAILERS.DRACO]: DRACO_CONFIG,
  [RETAILERS.SHANE]: SHANE_CONFIG,
  [RETAILERS.CETOINE]: CETOINE_CONFIG,
  [RETAILERS.DEFAULT]: DEFAULT_CONFIG,
  [RETAILERS.CHONDRUS]: CHONDRUS_CONFIG,
  [RETAILERS.LYNX]: LYNX_CONFIG,
  [RETAILERS.SCORPIO]: SCORPIO_CONFIG,
  [RETAILERS.LACERTA]: LACERTA_CONFIG,
  [RETAILERS.HYDRA]: HYDRA_CONFIG,
  [RETAILERS.CYGNUS]: CYGNUS_CONFIG,
  [RETAILERS.BOREAS]: BOREAS_CONFIG,
  [RETAILERS.STELLAR]: STELLAR_CONFIG,
};
